import { useContext, useCallback, useMemo } from 'react';
import { AlertContext } from '../components/AlertProvider';
/**
 * A hook that exposes several functions that can be used to display alerts.
 */
var useAlerts = function () {
    var _a = useContext(AlertContext), show = _a.show, alerts = _a.alerts, dismiss = _a.dismiss, dismissAll = _a.dismissAll;
    var showInfo = useCallback(function (contents, options) {
        return show('info', contents, options);
    }, [show]);
    var showError = useCallback(function (contents, options) {
        return show('error', contents, options);
    }, [show]);
    var showSuccess = useCallback(function (contents, options) {
        return show('success', contents, options);
    }, [show]);
    var showWarning = useCallback(function (contents, options) {
        return show('warning', contents, options);
    }, [show]);
    return useMemo(function () { return ({
        show: show,
        showInfo: showInfo,
        showError: showError,
        showSuccess: showSuccess,
        showWarning: showWarning,
        alerts: alerts,
        dismiss: dismiss,
        dismissAll: dismissAll,
    }); }, [
        show,
        showInfo,
        showError,
        showSuccess,
        showWarning,
        alerts,
        dismiss,
        dismissAll,
    ]);
};
export default useAlerts;
//# sourceMappingURL=useAlerts.js.map